import React from "react";
import PropTypes from "prop-types";
import { createMarkup } from "../../utils/miscHelper";
import styles from "./Preview.modules.scss";
import { Button } from "react-bootstrap";

const Sections = props =>{
  const { section, sectionWithSigned, isSigningDocument, addTouchScreenSignature, completeSectionSignature } = props;
  const checkSectionSignatureFiller = sectionWithSigned.filter(e => e.sectionId === section.sectionId);
  const renderEachSectionDescriptions = (section, sectionWithSigned) => {
    
    let content = section.sectionContent.replace(
      /<!-- pagebreak -->/g,
      "<br /><br />----------------------------------------------------------------------------------------------Page Break----------------------------------------------------------------------------------------------"
    );
    
    let checkIfStateSignatureExist = sectionWithSigned.filter(e => e.sectionId === section.sectionId);
    if (checkIfStateSignatureExist.length > 0) {
      return <div dangerouslySetInnerHTML={createMarkup(checkIfStateSignatureExist[0].sectionHtml)} />;
    } else {
      return content && section.sectionSignedHtml == null ? <div dangerouslySetInnerHTML={createMarkup(content)} /> : <div dangerouslySetInnerHTML={createMarkup(section.sectionSignedHtml)} />;
    }
  };
    return (
      <div style={{ marginTop: "30px", marginRight: "20px" }}>
        <div className="row">
          <div className="col-md-12" style={{ marginBottom: "30px" }}>
            {renderEachSectionDescriptions(section,sectionWithSigned)}
            {checkSectionSignatureFiller.length < 1 && section.isSectionSignatureRequired && section.sectionSignedHtml == null && (
              <span className={styles.sectionAgree} style={{ paddingTop: "20px", paddingBottom: "20px", width: "99%", backgroundColor: "#EFEFEF", display: "inline-table", marginTop: "10px", marginBottom: "17px" }}>
                <span style={{ float: "left" }}>{`I have read & Agree to this section`}</span>

                {section.isTouchSignatureUI ? (
                  <Button disabled={isSigningDocument} style={{ display: "block", float: "right" }} variant="success" size="sm" onClick={() => addTouchScreenSignature(section.sectionId)}>
                    {`Click here to Sign`}
                  </Button>
                ) : (
                  <Button disabled={isSigningDocument} style={{ display: "block", float: "right" }} variant="success" size="sm" onClick={() => completeSectionSignature(section.sectionId)}>
                    {`Agree & Sign`}
                  </Button>
                )}
              </span>
            )}
          </div>
        </div>
      </div>
    );
}
Sections.propTypes = {
  section : PropTypes.object.isRequired, 
  sectionWithSigned : PropTypes.array.isRequired, 
  isSigningDocument : PropTypes.bool.isRequired, 
  addTouchScreenSignature : PropTypes.func.isRequired, 
  completeSectionSignature : PropTypes.func.isRequired
};
export default Sections;